export const mailTypeEnum = {
  BUYER_MAIL: 'BuyerEmail',
  NR:'NR',
  NF:'NF',
  QA: 'QA',
  AMAZON_EMAIL: 'AmazonEmail',
  CARING_EMAIL: 'CareMail',
  CONTACT_BUYER: 'ContactBuyer',
  IMPORTANT_MAIL: 'ImportantMail'
};

export const mailTypeOptions = [
  { id:'BuyerEmail', text: '买家邮件' },
  { id:'NR', text: 'NR' },
  { id:'NF', text: 'NF' },
  { id:'QA', text: 'Q&A' },
  { id:'AmazonEmail', text: '亚马逊邮件' },
  { id:'CareMail', text: '关怀邮件' },
  { id:'ContactBuyer', text: '联系买家' }
]

export const mailTypeStatusEnum = {
  PENDING: 'Pending',
  TRACKING: 'Tracking',
  DONE: 'Done',
};

export const buyerEmailOrQAOption = [
  {id: 'subject', text: '主题'},
  {id: 'emailName', text: '发件人'},
  {id: 'orderId', text: '订单编号'},
  {id: 'asin', text: 'ASIN'},
  {id: 'ruleName', text: '规则名称'}
];


export const otherEmailOption = [
  {id: 'subject', text: '主题'},
  {id: 'emailName', text: '发件人'},
];
